/** Same Supabase project as v1 — same accounts, same data, same RLS.
 * The anon key is public by design (it ships to every browser); row access
 * is enforced server-side by RLS policies. v2 is READ-ONLY in Phase 1. */
export const SUPABASE_URL = "https://dssjbaohrercmzelucov.supabase.co";
export const SUPABASE_ANON_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRzc2piYW9ocmVyY216ZWx1Y292Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODI2NTU1MTYsImV4cCI6MjA5ODIzMTUxNn0.GuGxJS6rhXHU-2OA5vp6NOa41ohDcUoWTo4NoowPotU";
export const APP_BUILD = "v2-parity12-comps";

/** v1's Render backend — the SAME server v1 calls (flipbase-clone/config.js
 * CRM_CONFIG.API_BASE). It verifies the Supabase Bearer token itself and
 * resolves the org server-side; all integration credentials live there. */
export const API_BASE = "https://reicrm-api.onrender.com";
